import { faAdd } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PageLayout from "../components/PageLayout";
import { useEffect, useRef, useState } from "react";
import { ParseErrors } from "../utils/ParseErrors";
import axiosInstance from "../utils/axiosInstance";
import { InsuranceProviderInterface } from "../types/provider-types";
import ProviderTable from "../components/providerComponents/ProviderTable";
import ProviderFilterBar from "../components/providerComponents/provider-filter-bar";
import { useDebounceValue } from "usehooks-ts";
import GetUser from "../utils/getUser";
import PaginationMenu from "../components/pagination/paginationMenu";
import formQueryUrl from "../utils/formQueryUrl";
import ChatIcon from "../components/chat-components/chat-icon";

export default function Providers() {
  const currentUser = GetUser()
  const [providers, setProviders] = useState<InsuranceProviderInterface[]>([])
  const [search, setSearch] = useDebounceValue<string>("", 500)
  const [type, setType] = useState<"Sales" | "Renewals" | "all">("all")
  const [productType, setProductType] = useState<"Standard" | "Non-Standard" | "all">("all")
  const [totalCount, setTotalCount] = useState<number>(0)
  const [pageSize] = useState<number>(10)
  const searchRef = useRef<HTMLInputElement>(null)
  const [page, setPage] = useState<number>(1)
  const [loading, setLoading] = useState<boolean>(false)
  const navigate = useNavigate();


  // --------------------------------- [ FIND PROVIDERS ] --------------------------------
  useEffect(() => {
    const findProviders = async () => {
      const filtersArray = [{ name: search }, type !== "all" && { type: type }, productType !== "all" && { product: productType }]
      setLoading(true)
      try {
        const res = await axiosInstance.get(`/provider?page=${page}&limit=${pageSize}${formQueryUrl(filtersArray)}`)
        setProviders(res.data.data)
        setTotalCount(res.data.totalCount)
        setLoading(false)
      } catch (error) {
        ParseErrors(error)
        setLoading(false)
      }
    }

    findProviders()
  }, [search, page, pageSize, type, productType])


  // -------------------------------- [ UPDATE CURRENT PAGE ] --------------------------
  const OnChangeCurrentPage = (page) => {
    setPage(page)
  }

  return (
    <PageLayout
      pageTitle="Providers"
      primaryAction={
        <div className="flex items-center justify-end gap-2.5 flex-wrap smallTablet:justify-start smallTablet:w-full">
          <ChatIcon />
          {currentUser?.type === "super-admin" ? (
            <button
              onClick={() => navigate("/createInsurer")}
              className="flex gap-2 text-[15px] font-dmSans font-[600] items-center h-10 px-5 smallTablet:ml-auto text-white bg-gradient-to-r from-accent to-accent-bright shadow-lg shadow-indigo-500/20 hover:shadow-glow-sm hover:-translate-y-0.5 transition-all duration-300 rounded-full"
            >
              <FontAwesomeIcon icon={faAdd} className="text-[13px]" />
              Add Insurer
            </button>
          ) : null}
        </div>
      }
    >
      <ProviderFilterBar
        type={type}
        setType={setType}
        productType={productType}
        setProductType={setProductType}
        searchRef={searchRef}
        search={search}
        setSearch={setSearch}
        loading={loading}
      />

      <div className="mt-5 mr-1 smallTablet:mr-0 bg-surface border border-edge rounded-2xl shadow-card px-6 pt-6 pb-2 smallTablet:px-3 smallTablet:pt-4 font-medium animate-fade-in">
        <div className="mb-4 flex items-baseline justify-between gap-3 flex-wrap">
          <h2 className="text-[22px] font-bold text-text-primary leading-tight">
            Insurer rules
          </h2>
          <p className="text-[13px] font-medium text-light-gray">
            {new Intl.NumberFormat("en-GB").format(totalCount)} insurers
          </p>
        </div>
        <ProviderTable
          bodyData={providers}
          isLoading={loading}
          totalCount={totalCount}
        />
        <PaginationMenu totalCount={totalCount} currentPage={page} pageSize={pageSize} onPageChange={OnChangeCurrentPage} />
      </div>
    </PageLayout>
  );
}
